import { useState } from 'react'
import UserSelect from '../Statistics/UserSelect'
import UserAttributesGrid from './UserAttributesGrid'
import { makeInteger } from '../../utils'

export default function UserAttributes() {
  console.log('UserAttributes rendered: ')

  const [selectedUserId, setSelectedUserId] = useState()

  function handleUserChange(e) {
    console.log('UserAttribute.handleUserChange value: ', e.target.value)
    setSelectedUserId(makeInteger(e.target.value))
  }

  return (
    <div style={{ textAlign: 'center', height: '100%', overflow: 'auto' }}>
      <div style={{ display: 'inline-block', padding: '10px'}}>
        <UserSelect value={selectedUserId} handleChange={handleUserChange} firstItem={'Select A User'} />
      </div>
      <UserAttributesGrid userId={selectedUserId} />
    </div>
  )
}
